import React, { useState } from "react";
import { submitCifOffer } from "@/api/placeOffer";
import { acknowledgementStatement } from "@/setting";
import { BsCheckCircle, BsCheckCircleFill } from "react-icons/bs";
import { useDispatch, useSelector } from "react-redux";
import { getBidDepositDetail, saveCif, getCifDocuments } from "@/api/bid";
import { setBidAmount } from "@/bidFeature/bidwizardSlice";

const EditSubmit = ({
  cifId,
  cifData,
  setCollapseAccordian,
  collapseAccordian,
  submittedAccordions,
  setSubmittedAccordions,
  isEnabled,
  editCifUserData,
  listingId,
  pof,
  // listing,
  primaryBuyerData,
  cobuyerData,
  agentData,
  selectedDescription,
  buyingForSelf,
  hasCobuyer,
  primaryEntityType,
  cobuyerEntityType,
  uploadedFiles,
  setUploadedFiles, // Add this prop
  formState,
  isSubmitting,
  setIsSubmitting,
  setCifCompleted,
  commercialPof,
  titleInsuranceForm,
  closingAgentForm,
  selectedClosingOption,
  paymentFlag,
  setIsBidDeposit,
  winningBidUserEmail,
}) => {
  const [acknowledgement, setAcknowledgement] = useState(false);
  const [acknowledgementError, setAcknowledgementError] = useState();

  const [hasCheckboxInteracted, setHasCheckboxInteracted] = useState(false);

  const closingData = cifData?.data?.closingOptionDetails?.[0] || {};
  const closingDataDetails = cifData?.data?.closingDetail?.closingAgent;
  const titleInsuranceProvider =
    cifData?.data?.closingDetail?.titleInsuranceProvider;
  const {
    isClosingAgentRequired,
    isTitleInsuranceProviderRequired,
    closingOptionType,
    titleInsuranceFeeDetail,
  } = closingData;
  const listing = useSelector(
    (state) => state?.pdp?.pdpInitData?.propertyDetails
  );
  const listing_Price = useSelector(
    (state) => state?.propertyDetail?.getPropertyDetail
  );
  const dispatch = useDispatch();
  const [isCWCOTProp, setIsCWCOTProp] = useState(
    listing?.commonAttributes?.propCategory === "SC" &&
      listing?.address?.state !== "CA" &&
      listing?.cwcotUpdatesEnabled &&
      listing?.cwcotUpdatesValid
      ? true
      : false
  );
  const [isCWCOTCAProp, setIsCWCOTCAProp] = useState(
    listing?.commonAttributes?.propCategory === "SC" &&
      listing?.address?.state === "CA" &&
      listing?.cwcotUpdatesEnabled &&
      listing?.cwcotUpdatesValid
      ? true
      : false
  );

  const [isCABillProp, setIsCABillProp] = useState(() => {
    // 1. First check exclusion conditions - if these are true, it's definitely not a CA Bill property
    // Log initial values

    const isExcluded =
      listing_Price?.listingPriceDetail?.listingType === "TRNL" ||
      listing_Price?.propertyDetails?.commonAttributes?.propCategory ===
        "COMMERCIAL";

    if (isExcluded) {
      return false;
    }

    // 2. Then check if it meets CA Bill requirements
    const isCABillEligible =
      listing_Price?.stateWorkflowDurationActive === true &&
      listing_Price?.stateWorkflowEnabled === true &&
      !isCWCOTCAProp;

    return isCABillEligible;
  });

  const handleCheckboxChange = (event) => {
    const isChecked = event.target.checked;
    setAcknowledgement(isChecked);
    // Set or clear error message based on checkbox state
    setAcknowledgementError(
      event.target.checked ? "" : "Please accept the above acknowledgement."
    );
  };

  const generateUUID = () => {
    var randomNumber = new Date().getTime();
    var uuid = "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(
      /[xy]/g,
      function (c) {
        var r = (randomNumber + Math.random() * 16) % 16 | 0;
        randomNumber = Math.floor(randomNumber / 16);
        return (c === "x" ? r : (r & 0x3) | 0x8).toString(16);
      }
    );
    return uuid;
  };
  var templateId = generateUUID();

  const getBuyerCategory = () => {
    switch (primaryEntityType) {
      case "selfOccupancy":
        return "SELF_OCCUPANCY";

      case "hudNonProfit":
        return "HUD_APPROVED";

      case "government":
        return "GOVT_ENTITY";

      case "caBillOwnerOccupied":
        return "OWNER_OCCUPIED_BUYER";

      case "caBillNonProfit":
        return "NON_PROFIT_CORP";

      case "firstLookOwnerOccupied":
        return "FL_OWNER_OCCUPIED_BUYER";

      case "firstLookNonProfit":
        return "FL_QL_NON_PROFIT_CORP";

      case "caBillLandTrust":
        return "COMMUNITY_LAND_TRUST";

      case "caBillHousingCoop":
        return "LTD_EQUITY_HOUSING_CO";

      case "caBillCaliforniaState":
        return "STATE_OF_CA";
    }
  };

  const getBuyerCategoryName = () => {
    switch (primaryEntityType) {
      case "selfOccupancy":
        return primaryBuyerData.selfOccupancyName;

      case "hudNonProfit":
        return primaryBuyerData.hudNonProfitName;

      case "government":
        return primaryBuyerData.governmentName;

      case "caBillOwnerOccupied":
        return primaryBuyerData.caBillOwnerOccupiedName;

      case "caBillNonProfit":
        return primaryBuyerData.caBillNonProfitName;

      case "caBillLandTrust":
        return primaryBuyerData.caBillLandTrustName;

      case "caBillHousingCoop":
        return primaryBuyerData.caBillHousingCoopName;

      case "caBillCaliforniaState":
        return primaryBuyerData.caBillCaliforniaStateName;
    }
  };

  const getDocList = () => {
    const pofFiles = uploadedFiles.pofFiles;
    const buyerSelfCWCOTFiles = uploadedFiles.buyerSelfCWCOTFiles;
    const buyerLLCFiles = uploadedFiles.buyerLLCFiles;
    const caBillCommunityTrustlandFiles =
      uploadedFiles.caBillCommunityTrustlandFiles;
    const caBillEquHousingCoFiles = uploadedFiles.caBillEquHousingCoFiles;
    const caBillNonProfitCorpFiles = uploadedFiles.caBillNonProfitCorpFiles;
    const caBillOwnerOccupiedFiles = uploadedFiles.caBillOwnerOccupiedFiles;
    const caBillStateofCalifornia = uploadedFiles.caBillStateofCalifornia;
    const caBuyerCommunityTrustLandCWCOTFiles =
      uploadedFiles.caBuyerCommunityTrustLandCWCOTFiles;
    const caBuyerGovtCWCOTFiles = uploadedFiles.caBuyerGovtCWCOTFiles;
    const caBuyerLimEquHousingCooCWCOTFiles =
      uploadedFiles.caBuyerLimEquHousingCooCWCOTFiles;
    const caBuyerNonProfitCorpCWCOTFiles =
      uploadedFiles.caBuyerNonProfitCorpCWCOTFiles;
    const caBuyerOwnerOccupiedCWCOTFiles =
      uploadedFiles.caBuyerOwnerOccupiedCWCOTFiles;

    const caBuyerStateOfClaiforniaCWCOTFiles =
      uploadedFiles.caBuyerStateOfClaiforniaCWCOTFiles;
    const coBuyerLLCFiles = uploadedFiles.coBuyerLLCFiles;

    const allUploadedFiles = [
      pofFiles,
      buyerSelfCWCOTFiles,
      buyerLLCFiles,
      caBillCommunityTrustlandFiles,
      caBillEquHousingCoFiles,
      caBillNonProfitCorpFiles,
      caBillOwnerOccupiedFiles,
      caBillStateofCalifornia,
      caBuyerCommunityTrustLandCWCOTFiles,
      caBuyerGovtCWCOTFiles,
      caBuyerLimEquHousingCooCWCOTFiles,
      caBuyerNonProfitCorpCWCOTFiles,
      caBuyerOwnerOccupiedCWCOTFiles,
      caBuyerStateOfClaiforniaCWCOTFiles,
      coBuyerLLCFiles,
    ];

    // Filter out only those arrays that have data
    const nonEmptyUploadedFiles = allUploadedFiles.filter(
      (fileArray) => Array.isArray(fileArray) && fileArray.length > 0
    );

    // Optionally flatten if you want a single-level array of all files
    const allFilesFlat = nonEmptyUploadedFiles.flat();

    return allFilesFlat;
  };

  const handleFinalSubmit = async () => {
    try {
      setIsSubmitting(true);

      // Base payload structure
      const payload = {
        agentFlag: selectedDescription === "Agent" ? "Y" : "N",
        representedByAgent:
          (selectedDescription === "Buyer" && buyingForSelf === "Yes") ||
          (selectedDescription === "Agent" && buyingForSelf === "No")
            ? "Y"
            : "N",

        buyer: {
          firstName: primaryBuyerData.firstName,
          lastName: primaryBuyerData.lastName,
          middleInitials: primaryBuyerData.middleInitials || "",
          buyerCategory: getBuyerCategory(),
          address1: primaryBuyerData.address1,
          city: primaryBuyerData.city,
          zip: primaryBuyerData.zip,
          email: primaryBuyerData.email,
          phone: primaryBuyerData.phone,
          stateId: primaryBuyerData.stateId,
          buyerCategoryName: getBuyerCategoryName(),
        },

        agent: {
          firstName: agentData.firstName || "",
          lastName: agentData.lastName || "",
          middleInitials: agentData.middleInitials || "",
          companyName: agentData.agencyName || "",
          email: agentData.email || "",
          phone: agentData.phone || "",
          address1: agentData.address1 || "",
          address2: agentData.address2 || "",
          city: agentData.city || "",
          stateId: agentData.stateId || "",
          zip: agentData.zip || "",
          corpLicenceState: agentData.corporateLicenseState || "",
          corpLicenceNumber: agentData.corporateLicenseNumber || "",
          licenceState: agentData.individualLicenseState || "",
          licenceNumber: agentData.individualLicenseNumber || "",
          licenceExpiryDate: agentData.licenseExpiryDate || "",
        },

        newTemplate: "Y",
        updateFiles:
          getDocList().length > 0 || uploadedFiles.pof?.length > 0 ? "Y" : "N",
        listingId: listingId,
        userId: formState.profileDetails?.userDetails?.userId,
        documentIds: [],
        variationNumber: "v2",
        propertyStatus: "",
        cifId: cifId,

        cwcotUpdateEnabled: cifData?.data?.cwcotUpdateEnabled,
        cwcotUpdateValid: cifData?.data?.cwcotUpdateValid,
        isStateWorkflowDurationActive:
          cifData?.data?.isStateWorkflowDurationActive || "N",
        isStateWorkflowEnabled: cifData?.data?.isStateWorkflowEnabled,
        // First Look (SPS 945) flags
        firstLook: cifData?.data?.firstLook,
        firstLookExpiryDate:
          cifData?.data?.firstLookExpiryDate,
        templateId: cifData?.data?.templateId
          ? cifData?.data?.templateId
          : templateId,
      };
      if (
        selectedClosingOption
          ? selectedClosingOption
          : closingOptionType === "BUYER_PAYS"
      ) {
        payload.closingInfoChoice = "BuyerChosen";
      }
      if (
        selectedClosingOption
          ? selectedClosingOption
          : closingOptionType === "SELLER_PAYS"
      ) {
        payload.closingInfoChoice = "SellerChosen";
      }

      if (isClosingAgentRequired) {
        payload.closingAgent = {
          firstName: closingAgentForm.name,
          company: closingAgentForm.company,
          address1: closingAgentForm.address1,
          address2: closingAgentForm.address2,
          city: closingAgentForm.city,
          zip: closingAgentForm.zip,
          email: closingAgentForm.email,
          phone: closingAgentForm.phone,
          stateId: closingAgentForm.state,
        };
      }

      if (isTitleInsuranceProviderRequired) {
        payload.titleProvider = {
          firstName: titleInsuranceForm?.name,
          company: titleInsuranceForm?.company,
          address1: titleInsuranceForm?.address1,
          address2: titleInsuranceForm?.address2,
          city: titleInsuranceForm?.city,
          zip: titleInsuranceForm?.zip,
          email: titleInsuranceForm?.email,
          phone: titleInsuranceForm?.phone,
          stateId: titleInsuranceForm?.state,
        };
      }

      // Non-CWCOT logic
      if (primaryEntityType === "business") {
        payload.buyer.companyName = primaryBuyerData.companyName;
      }

      // Initialize documentIds array with primary buyer documents
      if (getDocList().length > 0) {
        payload.documentIds = getDocList().map((file) => file?.documentId);
      }

      // Add POF documents if they exist
      if (uploadedFiles.pof?.length > 0) {
        payload.documentIds = [
          ...payload.documentIds,
          ...uploadedFiles.pof.map((file) => file?.documentId),
        ];
      }

      // Add co-buyer data if exists
      if (hasCobuyer === "yes") {
        payload.coBuyer = {
          firstName: cobuyerData.firstName,
          lastName: cobuyerData.lastName,
          middleInitials: cobuyerData.middleInitials || "",
          address1: cobuyerData.address1,
          city: cobuyerData.city,
          zip: cobuyerData.zip,
          email: cobuyerData.email,
          phone: cobuyerData.phone,
          stateId: cobuyerData.stateId,
        };

        if (cobuyerEntityType === "business") {
          payload.coBuyer.companyName = cobuyerData.companyName;
        }

        // Add co-buyer documents if they exist
        if (uploadedFiles.coBuyer?.length > 0) {
          payload.documentIds = [
            ...payload.documentIds,
            ...uploadedFiles.coBuyer.map((file) => file?.documentId),
          ];
        }
      }

      const response = await saveCif(payload);

      // if (response?.data?.status === "SUCCESS") {
      //   setCifCompleted(true);

      //   window.scrollTo(0, 0);
      // } else {
      //   throw new Error(
      //     response?.data?.errorMessage || "Failed to save purchase profile"
      //   );
      // }
      if (response?.data?.status === "SUCCESS") {
        if (paymentFlag) {
          setCifCompleted(false);
          const payload = {
            bidAmount: 0,
            bidType: "PLACE_BID",
            buyerEmail: paymentFlag ? winningBidUserEmail : null,
            listingId: listingId || "0001744009899421AUCN2",
          };
          const bidDepositResponse = await getBidDepositDetail(payload);
          dispatch(setBidAmount(bidDepositResponse?.data?.data));
          if (bidDepositResponse?.data?.data?.bidDepositRequired === true) {
            setIsBidDeposit(true);
          }
        } else {
          setCifCompleted(true);
          window.scrollTo(0, 0);
        }
      } else {
        throw new Error(
          response?.data?.errorMessage || "Failed to save purchase profile"
        );
      }
    } catch (error) {
      console.error("Submit error:", error);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div
      className="accordion-item pof-accordion"
      style={{
        border: "1px solid  #dee2e6",
      }}
    >
      <h2 className="accordion-header">
        <button
          className={`accordion-button ${
            collapseAccordian === 5 ? "" : "collapsed"
          }`}
          type="button"
          onClick={(e) => e.preventDefault()}
          aria-expanded={collapseAccordian === 5}
        >
          <div className="d-flex align-items-center justify-content-between w-100">
            <div className="d-flex align-items-center">
              {/* Show black icon by default, green only if submitted */}
              {submittedAccordions?.includes(5) && collapseAccordian !== 5 ? (
                <BsCheckCircleFill className="icon_bid me-2" size={30} />
              ) : (
                <BsCheckCircleFill className="text-dark me-2" size={30} />
              )}
              <span className="bid_font_cif">Acknowledgement</span>
            </div>
          </div>
        </button>
      </h2>
      <div
        className={`accordion-collapse collapse ${
          collapseAccordian === 5 ? "show" : ""
        }`}
        data-bs-parent="#accordionFlushExample"
      >
        {isEnabled && (
          <div className="accordion-body ">
            <p className="d-flex mb-3">
              <input
                type="checkbox"
                name="acknowledgement"
                id="acknowledgement"
                className="form-check-input"
                onChange={handleCheckboxChange}
                checked={acknowledgement || false}
              />
              <label
                className="form-check-label  ms-3  ack-poff"
                for="acknowledgement"
              >
                {acknowledgementStatement}
              </label>
            </p>
            {/* Error message */}
            {acknowledgementError && (
              <div className="text-danger mb-3">
                <small>{acknowledgementError}</small>
              </div>
            )}

            <button
              type="submit"
              className="continueCTA"
              onClick={handleFinalSubmit}
              disabled={!acknowledgement}
              style={
                !acknowledgement
                  ? {
                      opacity: 0.65,
                      cursor: "not-allowed",
                      backgroundColor: "#b1c3d8",
                      borderColor: "#b1c3d8",
                    }
                  : {}
              }
            >
              {isSubmitting ? (
                <span>
                  <span className="spinner-border spinner-border-sm me-2" />
                  Submitting...
                </span>
              ) : (
                "Submit"
              )}
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default EditSubmit;
